import { useQuery } from "@tanstack/react-query";
import { organizationsQuery } from "../api";

interface Organization {
	businessIdentifier: string;
	organizationName: string;
}

// Hook to get a map of business identifiers to organization names (React Query select caches the map automatically)
export function useBusinessIdMap() {
	return useQuery({
		...organizationsQuery,
		select: (orgs: Organization[]) =>
			orgs?.reduce((map, org) => {
				map[org.businessIdentifier] = org.organizationName;
				return map;
			}, {} as Record<string, string>),
	});
}
